import { defineMessages } from 'react-intl'

/* eslint-disable max-len */
export default defineMessages({
  btnLabel: 'Select file',
  description: 'Add more information via data upload, such as a PDF. The maximum total upload size is limited to 25 MB.'
})
